/**
 * VERDENSTORE v2.0 — Theme Core
 * Cart drawer, mobile nav, predictive search, header scroll
 */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // ─── Header Scroll Effect ───
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    const scrollThreshold = 50;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > scrollThreshold) {
        header.classList.add('is-scrolled');
        header.classList.remove('is-transparent');
      } else {
        header.classList.remove('is-scrolled');
        if (document.body.classList.contains('is-home')) {
          header.classList.add('is-transparent');
        }
      }
      lastScroll = currentScroll;
    }, { passive: true });

    if (document.body.classList.contains('is-home') && window.pageYOffset < scrollThreshold) {
      header.classList.add('is-transparent');
    }
  }

  // ─── Mobile Navigation ───
  const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileClose = document.querySelector('[data-mobile-nav-close]');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      mobileToggle.setAttribute('aria-expanded', 'true');
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
      mobileToggle.setAttribute('aria-expanded', 'false');
    });
  }

  // ─── Mini Cart Drawer ───
  const miniCart = document.querySelector('[data-mini-cart]');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = document.querySelector('[data-mini-cart-close]');

  function openCart() {
    if (!miniCart) return;
    miniCart.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!miniCart) return;
    miniCart.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (miniCart) {
    miniCart.querySelector('.mini-cart__overlay')?.addEventListener('click', closeCart);
  }

  // ─── Cart API ───
  function fetchCart() {
    const cartBody = document.querySelector('[data-mini-cart-body]');
    const cartCount = document.querySelectorAll('[data-cart-count]');
    const cartFooter = document.querySelector('[data-mini-cart-footer]');

    fetch(window.theme.routes.cartUrl + '.js')
      .then(r => r.json())
      .then(cart => {
        cartCount.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        if (cart.item_count === 0) {
          if (cartBody) cartBody.innerHTML = `
            <div class="cart-empty">
              <div class="cart-empty__icon">🛒</div>
              <p>Twój koszyk jest pusty</p>
              <a href="/collections/all" class="btn btn--secondary" style="margin-top:1rem;">Zobacz produkty</a>
            </div>`;
          if (cartFooter) cartFooter.style.display = 'none';
          return;
        }

        if (cartFooter) cartFooter.style.display = 'block';
        if (!cartBody) return;

        cartBody.innerHTML = cart.items.map((item, i) => `
          <div class="cart-line" data-cart-line="${i}">
            <div class="cart-line__image">
              ${item.image ? `<img src="${item.image.replace(/_(small|medium)\./, '_200x.')}" alt="">` : ''}
            </div>
            <div class="cart-line__details">
              <p class="cart-line__title">${item.product_title}</p>
              ${item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${item.variant_title}</p>` : ''}
              <p class="cart-line__price">${formatMoney(item.final_line_price)}</p>
              <div class="cart-line__actions">
                <div class="quantity-selector">
                  <button type="button" data-qty-change="${i}" data-delta="-1">−</button>
                  <input type="number" value="${item.quantity}" min="0" data-qty-input="${i}">
                  <button type="button" data-qty-change="${i}" data-delta="1">+</button>
                </div>
                <button type="button" class="cart-line__remove" data-remove="${i}">Usuń</button>
              </div>
            </div>
          </div>
        `).join('');

        // Update subtotal
        const subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        // Bind events
        cartBody.querySelectorAll('[data-qty-change]').forEach(btn => {
          btn.addEventListener('click', () => {
            const idx = btn.dataset.qtyChange;
            const input = cartBody.querySelector(`[data-qty-input="${idx}"]`);
            const newQty = parseInt(input.value) + parseInt(btn.dataset.delta);
            if (newQty >= 0) updateCartItem(idx, newQty);
          });
        });

        cartBody.querySelectorAll('[data-remove]').forEach(btn => {
          btn.addEventListener('click', () => updateCartItem(btn.dataset.remove, 0));
        });
      });
  }

  function updateCartItem(line, quantity) {
    fetch(window.theme.routes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line) + 1, quantity: quantity })
    })
    .then(() => fetchCart())
    .catch(err => console.error('Cart error:', err));
  }

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return window.theme.moneyFormat.replace(/{{\s*amount\s*}}/g, value).replace('PLN', 'zł');
  }

  // ─── Add to Cart (Ajax) ───
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      const originalText = btn?.textContent || 'Dodaj do koszyka';

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Dodaję...';
      }

      const formData = new FormData(form);
      fetch(window.theme.routes.cartAddUrl + '.js', {
        method: 'POST',
        body: formData
      })
      .then(r => r.json())
      .then(() => {
        if (btn) {
          btn.textContent = '✓ Dodano!';
          btn.classList.add('btn--success');
        }
        fetchCart();
        openCart();
        setTimeout(() => {
          if (btn) {
            btn.disabled = false;
            btn.textContent = originalText;
            btn.classList.remove('btn--success');
          }
        }, 2000);
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      });
    });
  });

  // ─── Newsletter Popup ───
  const popup = document.querySelector('[data-newsletter-popup]');
  if (popup && !localStorage.getItem('verden_newsletter_closed')) {
    setTimeout(() => {
      popup.classList.add('is-visible');
    }, 15000);

    popup.querySelector('[data-newsletter-close]')?.addEventListener('click', () => {
      popup.classList.remove('is-visible');
      localStorage.setItem('verden_newsletter_closed', 'true');
    });

    popup.querySelector('.newsletter-popup__overlay')?.addEventListener('click', () => {
      popup.classList.remove('is-visible');
    });
  }

  // ─── Countdown Timer ───
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime();
    const nums = el.querySelectorAll('[data-countdown-num]');
    const labels = ['days', 'hours', 'minutes', 'seconds'];

    function update() {
      const now = new Date().getTime();
      const diff = end - now;
      if (diff <= 0) return;

      const values = [
        Math.floor(diff / (1000 * 60 * 60 * 24)),
        Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        Math.floor((diff % (1000 * 60)) / 1000)
      ];

      nums.forEach((num, i) => {
        num.textContent = String(values[i]).padStart(2, '0');
      });
    }

    update();
    setInterval(update, 1000);
  });

  // ─── Smooth Scroll for Anchor Links ───
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
